var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('main',{class:[{'mobile': !_vm.isDesktop}]},[(_vm.isDesktop)?[_c('div',{staticClass:"wrap"},[_c('b-header'),_vm._v(" "),_c('b-content')],1),_vm._v(" "),_c('b-footer')]:[_c('div',{staticClass:"wrap"},[_c('b-m-header'),_vm._v(" "),_c('b-m-content'),_vm._v(" "),_c('b-m-footer')],1)]],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be0e61b2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 512
// module chunks = 0